"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SixDataChainConnector = void 0;
const Accounts_1 = require("./Accounts");
const nftmngrModuleGenerate = __importStar(require("../modules/sixnft/thesixnetwork.sixnft.nftmngr/module/index"));
const nftoracleModuleGenerate = __importStar(require("../modules/sixnft/thesixnetwork.sixnft.nftoracle/module/index"));
const nftadminModuleGenerate = __importStar(require("../modules/sixnft/thesixnetwork.sixnft.nftadmin/module/index"));
const tokenmngrModuleGenerate = __importStar(require("../modules/six-protocol/thesixnetwork.sixprotocol.tokenmngr/module/index"));
const protocoladminModuleGenerate = __importStar(require("../modules/six-protocol/thesixnetwork.sixprotocol.protocoladmin/module/index"));
const cosmosbankModuleGenerate = __importStar(require("../modules/cosmos/cosmos-sdk/cosmos.bank.v1beta1/module/index"));
const cosmosstakingModuleGenerate = __importStar(require("../modules/cosmos/cosmos-sdk/cosmos.staking.v1beta1/module/index"));
const cosmosTx = __importStar(require("../modules/cosmos/cosmos-sdk/cosmos.tx.v1beta1/module/index"));
const distributionModuleGenerate = __importStar(require("../modules/cosmos/cosmos-sdk/cosmos.distribution.v1beta1/module/index"));
class SixDataChainConnector {
    /**
   * @param _nodeUrl is the url of the node to connect default is http://localhost
   * @param _portApi default is 1317
   * @param _portRpc default is 26657
   **/
    constructor(_nodeUrl = "http://localhost", _portApi = 1317, _portRpc = 26657) {
        this.accounts = new Accounts_1.Accounts();
        this.connectAPIClient = () => __awaiter(this, void 0, void 0, function* () {
            const [nftmngrModule, nftoracleModule, nftAdminModule, tokenmngrModule, protocolAdminModule, cosmosBankModule, cosmosStakingModule, cosmosTxModule, distributionModule] = yield Promise.all([
                nftmngrModuleGenerate.queryClient({ addr: this.apiUrl }),
                nftoracleModuleGenerate.queryClient({ addr: this.apiUrl }),
                nftadminModuleGenerate.queryClient({ addr: this.apiUrl }),
                tokenmngrModuleGenerate.queryClient({ addr: this.apiUrl }),
                protocoladminModuleGenerate.queryClient({ addr: this.apiUrl }),
                cosmosbankModuleGenerate.queryClient({ addr: this.apiUrl }),
                cosmosstakingModuleGenerate.queryClient({ addr: this.apiUrl }),
                cosmosTx.queryClient({ addr: this.apiUrl }),
                distributionModuleGenerate.queryClient({ addr: this.apiUrl })
            ]);
            return {
                nftmngrModule,
                nftoracleModule,
                nftAdminModule,
                tokenmngrModule,
                protocolAdminModule,
                cosmosBankModule,
                cosmosStakingModule,
                cosmosTxModule,
                distributionModule
            };
        });
        /**
        * @param accountSigner OfflineSigner
        * @example
        * const signer = await sixConnector.accounts.privateKeyToAccount("priveteKey")
        * const txClient = await sixConnector.connectRPCClient(signer)
        * @description connect to RPC client use for send transaction
        **/
        this.connectRPCClient = (accountSigner, options) => __awaiter(this, void 0, void 0, function* () {
            const [nftmngrModule, nftadminModule, nftoracleModule, tokenmngrModule, protocolAdminModule, cosmosBankModule, cosmosStakingModule, cosmosTxModule, distributionModule] = yield Promise.all([
                nftmngrModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options),
                nftadminModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options),
                nftoracleModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options),
                tokenmngrModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options),
                protocoladminModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options),
                cosmosbankModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options),
                cosmosstakingModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options),
                cosmosTx.txClient(accountSigner, { addr: this.rpcUrl }, options),
                distributionModuleGenerate.txClient(accountSigner, { addr: this.rpcUrl }, options)
            ]);
            return {
                nftmngrModule,
                nftadminModule,
                nftoracleModule,
                tokenmngrModule,
                protocolAdminModule,
                cosmosBankModule,
                cosmosStakingModule,
                cosmosTxModule,
                distributionModule
            };
        });
        this.removeSLash = (url) => {
            if (url[url.length - 1] === "/")
                return url.slice(0, -1);
            return url;
        };
        const url = this.removeSLash(_nodeUrl);
        this.apiUrl = url + ":" + _portApi;
        this.rpcUrl = url + ":" + _portRpc;
    }
}
exports.SixDataChainConnector = SixDataChainConnector;
// InitQueryClient = async (
//     module: "nftmngrModule" | "evmsupportModule" | "adminModule" | "nftoracleModule",
//     addr: string
// ) => {
//     switch (module) {
//         case "nftmngrModule":
//             return await this.modules.nftmngrModule.queryClient({ addr: addr })
//         case "evmsupportModule":
//             return await this.modules.evmsupportModule.queryClient({ addr: addr })
//         case "adminModule":
//             return await this.modules.adminModule.queryClient({ addr: addr })
//         case "nftoracleModule":
//             return <Api>(await this.modules.nftoracleModule.queryClient({ addr: addr }))
//     }
// }
//# sourceMappingURL=SixDataChainConnector.js.map